import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { PhasesSection } from './components/PhasesSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal selection:bg-brand-sage selection:text-brand-forest" data-id="element-0" data-mp="31agnwnhawdix">
      <Navigation data-id="element-1" data-mp="2wiyvwox99na3" />
      <main data-id="element-2" data-mp="2wifbn1k4umsw">
        <Hero data-id="element-3" data-mp="2whx95n6vnccj" />
        <ProblemSection data-id="element-4" data-mp="28ufpkexrnkkn" />
        <PhasesSection data-id="element-5" data-mp="28tw3qn4zwc1c" />
        <PricingSection data-id="element-6" data-mp="28t4lsf4bmctj" />
        <FAQSection data-id="element-7" data-mp="28sbbj465l56n" />
        <FinalCTASection data-id="element-8" data-mp="23vck4tdvjcc5" />
      </main>
      <Footer data-id="element-9" data-mp="23u9ueosaffxt" />
    </div>;
}